import React, { forwardRef } from 'react';
import { withRouter } from 'react-router-dom';

const withRouterForwardRef = (Component: any): any => {
  const WithRouter = withRouter(({ forwardedRef, ...props }: any): any => (
    <Component ref={forwardedRef} {...props} />
  ));

  return forwardRef((props: any, ref: any): any => (
    <WithRouter {...props} forwardedRef={ref} />
  ));
};

export default withRouterForwardRef;
